import { RouteCodes } from '@core/config/route-codes';
import { POSITION_ROUTES_TREE } from '@core/config/routes-tree';
import { StepConfigModel } from '@models/wizard/steps-config.model';

export const STEPS_CONFIG: {
  [stepCode: string]: StepConfigModel;
} = {
  ['CONS-PRIVACY']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['ATC-SEARCH']: {
    path: POSITION_ROUTES_TREE[RouteCodes.atcChoice].path
  },
  ['RICO-CLI']: {
    path: POSITION_ROUTES_TREE[RouteCodes.recognition].path
  },
  ['UPL-DOC']: {
    path: POSITION_ROUTES_TREE[RouteCodes.documentsRequest].path
  },
  ['FUND-CHOICE']: {
    path: POSITION_ROUTES_TREE[RouteCodes.fundChoice].path
  },
  ['PENSION-DATA']: {
    path: POSITION_ROUTES_TREE[RouteCodes.pensionData].path
  },
  ['PAYCHECK']: {
    path: POSITION_ROUTES_TREE[RouteCodes.financialData].path
  },
  ['WEB-GEST-IMP']: {
    path: POSITION_ROUTES_TREE[RouteCodes.obligations].path
  },
  ['CONF-SIM']: {
    path: POSITION_ROUTES_TREE[RouteCodes.quotation].path
  },
  ['VALUTATION']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['WEB-QUEST']: {
    path: POSITION_ROUTES_TREE[RouteCodes.adequacy].path
  },
  ['WEB-STAMP-CONTR']: {
    path: POSITION_ROUTES_TREE[RouteCodes.contractSigning].path
  },
  ['SALARY-DATA']: {
    path: POSITION_ROUTES_TREE[RouteCodes.salaryData].path
  }
};
